import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../../helpers/constants";
import { getCookie } from "../../helpers/cookies";

const hourlySlotsApis = createApi({
    reducerPath: "hourlySlotsApis",

    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,

        prepareHeaders: (headers) => {
            const token = getCookie("asmc_token");

            if (token) {
                headers.set("Authorization", `BEARER ${token}`);
            }

            return headers;
        },
    }),

    keepUnusedDataFor: 0,

    tagTypes: ["HourlySlots"],

    endpoints: (build) => ({
        getHourlyActivities: build.query({
            query: () => ({
                url: "/hourly-slots/activities",
                method: "GET",
            }),
            transformResponse: (response) => response.result,
            providesTags: ["HourlySlots"],
        }),

        getHourlyLocations: build.query({
            query: (activityId) => ({
                url: "/hourly-slots/locations",
                method: "GET",
                params: {
                    activity_id: activityId,
                },
            }),
            transformResponse: (response) => response.result,
            providesTags: ["HourlySlots"],
        }),
        getHourlyCourts: build.query({
            query: ({ activityId, locationId }) => ({
                url: "/hourly-slots/courts",
                method: "GET",
                params: {
                    activity_id: activityId,
                    location_id: locationId,
                },
            }),
            transformResponse: (response) => response.result,
            providesTags: ["HourlySlots"],
        }),
        findHourlySlots: build.mutation({
            query: (data) => ({
                url: "/hourly-slots/find",
                method: "POST",
                body: data,
            }),
            transformResponse: (response) => response.result,
        }),
    }),
});

export const {
    useGetHourlyActivitiesQuery,
    useGetHourlyLocationsQuery,
    useGetHourlyCourtsQuery,
    useFindHourlySlotsMutation,
} = hourlySlotsApis;

export default hourlySlotsApis;